  document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('prod_video_thumb_slider')) {
      let prodVideoThumbSlider = new Splide('#prod_video_thumb_slider', {
        type: 'slide',
        gap: 10,
        drag: "free",
        snap: true,
        interval: 4000,
        autoplay: true,
        pauseOnHover: false,
        arrows: true,
        pagination: false,
        autoWidth: true, 
        omitEnd: true,
      });
      prodVideoThumbSlider.mount();
    }
  });
